module.exports = __webpack_public_path__ + "static/Arno-3294c07324e4ba8d40dd4cb318dcc1b2.jpg";